import React, {useEffect} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Card, List, Space} from 'antd';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import Text from 'antd/lib/typography/Text';
import Flex from '../../components/Flex';
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import ArticleDetailCard from '../../components/article/DetailCard';

export default function ArticleListPage(props: {catalogs: string}) {
  const searchHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSearchGet);
  useEffect(() => {
    searchHook
      .request({catalogs: props.catalogs, pi: 1, ps: 999})
      .then()
      .catch(CommonApiErrorHandler);
  }, [props.catalogs]);
  const history = useHistory();
  const detailMode = searchHook.data && searchHook.data.total === 1;
  return (
    <AppSideLayout title={props.catalogs}>
      {detailMode && searchHook.data?.list ? (
        <ArticleDetailCard article={searchHook.data?.list[0]} />
      ) : (
        <Card style={{flex: 1}} title={props.catalogs}>
          <List
            pagination={{pageSize: 20}}
            dataSource={searchHook.data?.list || []}
            className={'LargeList'}
            renderItem={item => (
              <Flex className={'ArticleListItem'} justify={'space-between'} onClick={() => window.open('/#/article/' + item.id, '_blank')}>
                <Space>
                  <div className={'SquareDot'} />
                  <Text style={{fontSize: 16}}>{item.title}</Text>
                </Space>
                <Text type={'secondary'}>[{moment(item.publishedDate).format('YYYY-MM-DD')}]</Text>
              </Flex>
            )}
          />
        </Card>
      )}
    </AppSideLayout>
  );
}
